import Resource from '@/api/resources/Resource'

class RegistryCaseServices extends Resource {
    async createCase(labId, params) {
        const response = await this.axios.post(`/registry/laboratories/${labId}/cases`, params)
        return response.data
    }

    async createCaseByWizard(labId, params) {
        const response = await this.axios.post(`/registry/laboratories/${labId}/registrationCases`, params)
        return response.data
    }

    async deleteCase(labId, casId) {
        const response = await this.axios.delete(`/registry/laboratories/${labId}/cases/${casId}`)
        return response.data
    }

    async lastModifiedCases(labId) {
        const response = await this.axios.get(`/registry/laboratories/${labId}/cases/lastModifiedCases`)
        return response.data
    }

    async getCase(labId, casId) {
        const response = await this.axios.get(`/registry/laboratories/${labId}/cases/${casId}`)
        return response.data
    }

    async updateCase(labId, casId, form, deleteSamplesIfIncompatible) {
        let params = { deleteSamplesIfIncompatible: !!deleteSamplesIfIncompatible }
        const response = await this.axios.put(`/registry/laboratories/${labId}/cases/${casId}`, form, { params })
        return response.data
    }

    async registerCase(labId, casId, params) {
        const response = await this.axios.put(`registry/laboratories/${labId}/cases/${casId}/register`, params)
        return response.data
    }

    async paginator(filterModel, params, laboratoryId) {
        // TODO: backend needs to change this paginator to PUT method
        const response =
            await this.axios.get(
                `/registry/laboratories/${laboratoryId}/cases`,
                {
                    params: {
                        ...params,
                        filterModel
                    }
                })
        return response.data
    }

    async updateAssociatedCases(labId, casId, entityIdentifiers) {
        const response = await this.axios.put(`registry/laboratories/${labId}/cases/${casId}/associatedCases`, { entityIdentifiers })
        return response.data
    }

    async reassignPatient(labId, casId, patId) {
        const response = await this.axios.put(`registry/laboratories/${labId}/cases/${casId}/reassignPatient`, null, {
            params: {
                patId
            }
        })
        return response.data
    }

    async caseSummary(labId) {
        return this.axios.get(`/registry/laboratories/${labId}/cases/summary`).then(response => response.data)
    }

    async findCaseByLabel(laboratoryId, caseLabel) {
        return this.axios.get(`/registry/laboratories/${laboratoryId}/cases/${caseLabel}/findByLabel`).then(response => response.data)
    }
}

export default new RegistryCaseServices()
